const api = {};

api.ANALYSIS = {
  getEntitiesWithAttr: "/queryMetadata/entitiesWithAttr",
  getNodeEdgeMapping: "/queryMetadata/nodeEdgeMapping",
  runQuery: "/query/complex",
  runComplexQueryForSimple: "/query/complexForSimple",
  runComplexQueryForGeographicalAnalysis: "/query/complexForGeographicalAnalysis",
  runComplexQueryForFollowers: "/query/complexForFollowers",
  runComparatorQuery: "/query/compare",
  runSingleQuery: "/query/simple",
  runSingleQueryForFollowers: "/query/simpleForFollowers",
  runSingleQueryForMomentaryFollowers: "/query/simpleForMomentaryFollowers",
  getEntityActions: "/queryMetadata/entityActions",
  expandQuery: "/query/expand",
  getDynamicEntityActionFilter: "/queryMetadata/dynamicEntityAction",
  runExpandCommon: "/query/expandCommon",
  runGlobalQuery: "/query/global",
  getCommonEntities: "/queryMetadata/commonEntities",
  createAnalysis: "/analysis/analysis",
  deleteAnalysis: "/analysis",
  wholeExpandQuery: "/query/wholeExpand",
  wholeComplexQuery: "/query/wholeComplex",
  wholeComplexQueryWithAggregation: "/query/wholeComplexWithAggregation",
  wholeComplexQueryForGeo: "/query/wholeComplexForGeo",
  dashboardWholeComplexQuery: "/query/dashboardWholeComplex",
  getParameterEntitiesValues: "/query/parameterEntitiesValues",
  getSibParameterEntitiesValues: "/query/sibParameterEntitiesValues",
  getPtsPoints: "/geographicalAnalysis/points",
  getAllPtsPoints: "/geographicalAnalysis/allPoints",
  getPersonFromId: "/query/personfromid",
  getIdFromPhoto: "/query/idfromphoto",
  getPhotosFromId: "/narkoQuery/photos",
  getHksPhotosFromId: "/narkoQuery/hksPhotos",
  getPtsPhotos: "/query/fetchPTSphoto",
  getAnalysisData: "/analysis/analysisData",
  saveDraftAnalysis: "/analysis/analysisDraft",
  updateDraftAnalysis: "/analysis/analysisDraft",
  getAnalysisList: "/analysis/analysisList",
  FetchIcon: "/queryMetadata/Icon",
  FetchIconSource: "/queryMetadata/iconsource",
  FetchPtsPhoto: "/query/pts",
  PostRoute: "/query/PostRoute",
  getPtsCoordinate: "/geographicalAnalysis/coordinates",
  getMaxQueryNo: "/analysis/maxQueryNo",
  getPersonPhoto: "/query/photoString",
  getComplexQueryDQL: "/query/complexQueryDQL",
  getWholeComplexQueryDQL: "/query/wholeComplexDQL",
  containerizeQuery: "/query/containerize-query",
  executeWithContainers: "/query/execute-with-containers"
};

api.AUTOSAVEDSCHEMA = {
  saveSchemaAutomatically: "/autosavedSchema",
  getAutoSavedAnalysis: "/autosavedSchema/analysis",
  getSelectedSchemasData: "/autosavedSchema/selectedSchemas",
  deleteAutosavedAnalysis: "/autosavedSchema",
  deleteSchema: "/autosavedSchema/schema"
};

api.SCENARIO = {
  saveScenario: "/scenario/scenario",
  getMyScenarios: "/scenario/myScenarios",
  getAllScenarios: "/scenario/allScenarios",
  updateScenarioForActive: "/scenario/updateScenarioForActive",
  deleteScenario: "/scenario/deleteScenario",
  getScenario: "/scenario/getScenario",
  getCommonUsersForNotification: "/scenario/commonUsers",
  getCommonUsersForFaceQueryNotification: "/scenario/commonUsersForFaceQuery",
  changeScenarioApprovalStatus: "/scenario/scenarioApprovalStatus",
  getScenarioDescription: "/scenario/description",
  updateScenarioDescription: "/scenario/description",
  scenarioHistories: "/scenario/histories",
  advancedScenarioHistories: "/scenario/advancedScenarioHistories",
  scenarioHistoriesFilters: "/scenario/historiesFilters",
  allScenarioForHistory: "/scenario/allScenarioForHistory",
  scenarioRule: "/scenario/scenarioRules",
  scenarioHighlights: "/scenario/scenarioHighlights",
  updateSummaryTemplate: "/Scenario/scenarioSummaryTemplate"
};

api.FACEQUERYSCENARIO = {
  createFaceQueryScenario: "/faceQueryScenario",
  updateFaceQueryScenario: "/faceQueryScenario",
  getAllFaceQueryScenarios: "/faceQueryScenario",
  getAllMyFaceQueryScenarios: "/faceQueryScenario/mine",
  getFaceQueryScenarioWithId: "/faceQueryScenario/withId",
  deleteFaceQueryScenario: "/faceQueryScenario",
  updateFaceQueryStatus: "/faceQueryScenario",
  addPhotosToFaceQueryScenario: "/faceQueryScenario/photos",
  getFaceQueryScenarioImages: "/faceQueryScenario/photos",
  getSelectedFQImageCount: "/faceQueryScenario/photoCount",
  deleteFaceQueryScenarioImages: "/faceQueryScenario/photos",
  changeScenarioApprovalStatus: "/faceQueryScenario/scenarioApprovalStatus",
  getScenarioDescription: "/faceQueryScenario/description"
}



api.AUTOEXPANDENTITYACTIONS = {
  getApprovedEntityActions: "/autoExpandEntityActions",
  saveSelectedAutoExpandEntityActions: "/autoExpandEntityActions",
  getUsersEntityActionsForLocalStorage: "/autoExpandEntityActions/login",
  wholeAutoExpandQuery: "/autoExpandEntityActions/expand"
}

api.MANAGEMENT = {
  entity: {
    getEntities: "/entityManagement/entities",
    getStackedEntities: "/entityManagement/stackedEntities",
    getNodeTypeEntities: "/entityManagement/nodeTypeEntities",
    deleteEntity: "/entityManagement/entities",
    createNewEntity: "/entityManagement/entities",
    updateEntity: "/entityManagement/entities",
    getEntitiesWithEntityAttributes:
      "/entityManagement/entities/entityattributes",
    getEntitiesAttributesWithMappings:
      "/entityManagement/entities/entityattributemappings",
    getEntitiesWithAttributeMappings:
      "/entityManagement/entities/attributemappings",
    getAllIconCategories: "/entityManagement/entities/iconcategories",
    getSelectedCategoryIcons: "/entityManagement/entities/icons",
    deleteEntityPropertyIcon: "/entityManagement/entityPropertyIcon"
  },
  attribute: {
    getAttributes: "/attributeManagement/attributes",
    deleteAttribute: "/attributeManagement/attributes",
    createNewAttribute: "/attributeManagement/attributes",
    updateAttribute: "/attributeManagement/attributes"
  },
  entityAttributes: {
    getNodesAndEdgesAsEntityList: "/entityAttributesManagement/nodesAndEdges",
    getEntitiesWithAttributes:
      "/entityAttributesManagement/entityAttributes",
    createNewEntityAttribute:
      "/entityAttributesManagement/entityAttributes",
    deleteEntityAttribute:
      "/entityAttributesManagement/entityAttributes",
    updateEntityAttribute:
      "/entityAttributesManagement/entityAttributes",
    getSourceAndTargetNodesWithEdge: "/entityAttributesManagement/sourceAndTargetNodesWithEdge",
    getEntitiesWithoutDatatableWithAttributes: "/entityAttributesManagement/entitiesWithoutDatatableWithAttributes",
    getSelectedEntityAttributes: "/entityAttributesManagement/entityAttribute",
  },
  dataSources: {
    getDataSources: "/dataSourceManagement/datasources",
    getDatasourcesWithDetails:
      "/dataSourceManagement/datasources/details",
    deleteDatasource: "/dataSourceManagement/datasources",
    createNewDatasource: "/dataSourceManagement/datasources",
    updateDatasource: "/dataSourceManagement/datasources"
  },
  dataTables: {
    getDataTables: "/dataTableManagement/datatables",
    createNewDataTable: "/dataTableManagement/datatables",
    deleteDataTable: "/dataTableManagement/datatables",
    updateDataTable: "/dataTableManagement/datatables",
    createDbAndTable: "/dataTableManagement/createdbanddatatable",
  },
  additionalEntitiesDatatables: {
    getAdditionalEntityDataTables: "/dataTableManagement/additionalDatatables",
    createAdditionalEntityDataTable: "/dataTableManagement/additionalDatatables",
    deleteAdditionalEntityDataTable: "/dataTableManagement/additionalDatatables",
    updateAdditionalEntityDataTable: "/dataTableManagement/additionalDatatables",
  },
  attributeMappings: {
    createNewAttributeMapping: "/attributeMappingManagement/attributemappings",
    deleteAttributeMapping: "/attributeMappingManagement/attributemappings",
    updateAttributeMapping: "/attributeMappingManagement/attributemappings"
  },
  nodeEdgeMappings: {
    getNodeEdgeMappings: "/nodeEdgeMappingManagement/nodeedgemappings",
    getNodeEdgeMappingsWithEntityAttributes:
      "/nodeEdgeMappingManagement/nodeedgemappings/entityattributes",
    createNewNodeEdgeMapping: "/nodeEdgeMappingManagement/nodeedgemappings",
    deleteNodeEdgeMapping: "/nodeEdgeMappingManagement/nodeedgemappings",
    updateNodeEdgeMapping: "/nodeEdgeMappingManagement/nodeedgemappings",
    getEntityRelatedNodeEdgeMappings: "/nodeEdgeMappingManagement/entityRelatedNems",
    getNemEntityAttributes: "/nodeEdgeMappingManagement/nemEntityAttributes",
  },
  nodeEdgeMappingDetails: {
    getNodeEdgeMappingsDetails: "/nodeEdgeMappingDetailManagement/nodeedgemappingsdetails",
    getEntityAttributesFromNodeEdgeMapId:
      "/nodeEdgeMappingDetailManagement/entityattributesfromnodeedgemapid",
    changeEntityAttributeVisibility: "/nodeEdgeMappingDetailManagement/changenodeedgemappingvisibility",
    changeEntityAttributeOrder: "/nodeEdgeMappingDetailManagement/changenodeedgemappingorder",
    changeEntityAttributeFilterability: "/nodeEdgeMappingDetailManagement/changenodeedgemappingfilterability",
    changeEntityAttributeAlias: "/nodeEdgeMappingDetailManagement/changeentityattributealias",
    deleteAllRecords: "/nodeEdgeMappingDetailManagement/deleteallrecords"
  },
  entityMappings: {
    getEntityMappings: "/entityMappingManagement/entitymappings",
    getEntityMappingsForManagement: "/entityMappingManagement/entityMappingsForManagement",
    createNewEntityMapping:
      "/entityMappingManagement/entitymappings",
    deleteEntityMapping:
      "/entityMappingManagement/entitymappings",
    updateEntityMapping: "/entityMappingManagement/entitymappings"
  },
  subEntities: {
    getSubEntities: "/subEntityManagement/subentities",
    createNewSubEntity: "/subEntityManagement/subentities",
    deleteSubEntity: "/subEntityManagement/subentities",
    updateSubEntity: "/subEntityManagement/subentities"
  },
  entityActions: {
    getEntityActions: "/entityActionsManagement/entityactions",
    createNewEntityAction:
      "/entityActionsManagement/entityactions",
    deleteEntityAction: "/entityActionsManagement/entityactions",
    updateEntityAction: "/entityActionsManagement/entityactions"
  },
  commonEntities: {
    getCommonEntities: "/commonEntitiesManagement/commonEntities",
    createNewCommonEntity: "/commonEntitiesManagement/commonEntities",
    deleteCommonEntity: "/commonEntitiesManagement/commonEntities",
    updateCommonEntity: "/commonEntitiesManagement/commonEntities"
  },
  commonEntityDetails: {
    getCommonEntityDetails: "/commonEntitiesDetailsManagement/commonEntitiesDetails",
    createNewCommonEntityDetail: "/commonEntitiesDetailsManagement/commonEntitiesDetails",
    deleteCommonEntityDetail: "/commonEntitiesDetailsManagement/commonEntitiesDetails",
    updateCommonEntityDetail: "/commonEntitiesDetailsManagement/commonEntitiesDetails"
  },
  userManagement: {
    getUsers: "/userManagement/users",
    createNewUser: "/userManagement/users",
    updateUser: "/userManagement/users",
    updateUserRole: "/userManagement/userRole",
    deleteUser: "/userManagement/users",
    approve: "/userManagement/approve",
  },
  asenaUserManagement: {
    getAsenaUsers: "/asenaUserManagement",
    createAsenaUser: "/asenaUserManagement",
    updateAsenaUser: "/asenaUserManagement",
    deleteAsenaUser: "/asenaUserManagement",
    getUnitList: "/asenaUserManagement/unitList",
  },
  parameterAttributeFilters: {
    getParameterAttributeFilters: "/parameterAttributeFilters",
    createParameterAttributeFilter: "/parameterAttributeFilters",
    updateParameterAttributeFilter: "/parameterAttributeFilters",
    deleteParameterAttributeFilter: "/parameterAttributeFilters",
  },
  roleManagement: {
    roles: "/roleManagement",

  },
  rolePermissionManagement: {
    rolesWithPermissions: "/rolePermissionManagement",
    addAllEntityPermissions: "/rolePermissionManagement/allEntityPermissions",
    addParameterEntitiesPermissions: "/rolePermissionManagement/parameterEntitiesPermissions",
    addThothBIPermissions: "/rolePermissionManagement/thothBIPermissions",
  },
  permissionManagement: {
    permissions: "/permissionManagement",
    entityPermissions: "/permissionManagement/entityPermissions",
    mainPermissions: "/permissionManagement/mainPermissions"
  },
  thothBIPermissionManagement: {
    savePermission: "/thothBIPermissionManagement"
  },
  userRoleManagement: {
    usersWithRoles: "/userRoleManagement"
  },
  jandarmaOfficeRoleManagement: {
    officeRoles: "/jandarmaOfficeRoleManagement"
  },
  jandarmaOfficeManagement: {
    offices: "/jandarmaOfficeManagement/offices",
    approve: "/jandarmaOfficeManagement/approve",
    officeRoles: "/jandarmaOfficeManagement/officeRoles",
    addUser: "/jandarmaOfficeManagement/user",
    exportExcel: "/jandarmaOfficeManagement/excel",
  },
  entityFilterManagement: {
    entityFilter: "/entityFilterManagement"
  },
  entityTrackingAttributesManagement: {
    entityTrackingAttributes: "/entityTrackingAttributes",
    trackingAttribute: "/entityTrackingAttributes/trackingAttribute"
  },
  integratedAttributesManagement: {
    entityIntegratedAttributes: "/integratedQueryAttributes",
    integratedAttribute: "/integratedQueryAttributes/integratedAttribute"
  },
  globalSearchFilters: {
    globalSearchLabels: "/globalSearchFilters/labels",
    newLabel: "/globalSearchFilters/newLabel",
    globalSearchFilter: "/globalSearchFilters",
    globalSearchLabel: "/globalSearchFilters/label",
    deleteGlobalSearchFilter: "/globalSearchFilters/filter",
    deleteGlobalSearchLabel: "/globalSearchFilters/label",
    labelsForSearch: "/globalSearchFilters/labelsForSearch"
  },
  globalSearchReports: {
    globalSearchReports: "/globalSearchReports",
    newReport: "/globalSearchReports",
    deleteReport: "/globalSearchReports",
    updateReport: "/globalSearchReports"
  },
  globalSearchReportTemplateDetails: {
    reportTemplates: "/globalSearchReportTemplateDetails",
    newReportTemplate: "/globalSearchReportTemplateDetails",
    deleteTemplate: "/globalSearchReportTemplateDetails",
    updateTemplate: "/globalSearchReportTemplateDetails"
  },

  scenarioAlertStates: {
    getScenarioAlertStates: "/scenarioAlertStateManagement",
    createScenarioAlertState: "/scenarioAlertStateManagement",
    updateScenarioAlertState: "/scenarioAlertStateManagement",
    deleteScenarioAlertState: "/scenarioAlertStateManagement",
    createScenarioAlertStateChange: "/scenarioAlertStateManagement/changes",
    updateScenarioAlertStateChange: "/scenarioAlertStateManagement/changes",
    deleteScenarioAlertStateChange: "/scenarioAlertStateManagement/changes",
  },
  nemGrouping: {
    createGrouping: "/nemGroupingDetail",
    getGroupDetails: "/nemGroupingDetail",
    updateGrouping: "/nemGroupingDetail",
    deleteGrouping: "/nemGroupingDetail"
  },
  relationReports: {
    getRelationReports: "/relationReports",
    createRelationReport: "/relationReports",
    updateRelationReport: "/relationReports",
    deleteRelationReport: "/relationReports",
    getSelectedEntityReportDetails: "/relationReports/detail",
    createRelationReportDetail: "/relationReports/detail",
    deleteRelationReportDetail: "/relationReports/detail",
  },
  preparedQueryHeaders: {
    getPreparedQueryHeaders: "/preparedQueryHeaders",
    getPreparedQueryHeadersWithoutPerms: "/preparedQueryHeaders/withoutPerm",
    createPreparedQueryHeader: "/preparedQueryHeaders",
    updatePreparedQueryHeader: "/preparedQueryHeaders",
    deletePreparedQueryHeader: "/preparedQueryHeaders",
    updatePreparedQueryOrder: "/preparedQuery/order",
    getCustomerDetailPreparedQueries: "/preparedQueryHeaders/customerDetail",
    getPreparedQueryHeadersForQuery: "/preparedQueryHeaders/query",
    updateHeaderIcons: "/preparedqueryHeaders/updateIcons"
  },
  sibJson: {
    getSibJson: "/sib/mapping",
    updateSibJson: "/sib/json",
  },
  clientSettings: {
    crud: "/clientSettings",
    getClientSettingsShowOnClient: "/clientSettings/showOnClient"
  },
  scoreColorSettings: {
    crud: "/scenarioalertscoreColorSettingManagement"
  },
  kycScoreColorSettings: {
    crud: "/kycScoreColorSettingManagement"
  }
};

api.RELATIONREPORT = {
  getEntitiesRelationReports: "/relationReports/entity"
}

api.PLATETRACKING = {
  getAllPlateTrackings: "/plateTrackingSystem/plateTrackingSystem",
  createNewPlateTracking: "/plateTrackingSystem/plateTrackingSystem",
  updatePlateTracking: "/plateTrackingSystem/plateTrackingSystem",
  deletePlateTracking: "/plateTrackingSystem/plateTrackingSystem",
  getCommonUsersForNotification: "/plateTrackingSystem/commonUsers",
  getSelectedCommonUsersForNotification: "/plateTrackingSystem/selectedCommonUsersForNotification",
  changeAllPTSStatus: "/plateTrackingSystem/allStatus",
  deleteAllSelectedPlateTrackings: "/plateTrackingSystem/allSelected",
  getPlateTrackingNotifications: "/plateTrackingSystem/notifications"
}

api.EXCELDRAFT = {
  createNewBankAnalysis: "/excelDraft/bankAnalysis",
  getBankAnalysisList: "/excelDraft/bankAnalysis",
  deleteBankAnalysis: "/excelDraft/bankAnalysis",
  saveBankAnalysisExcelData: "/excelDraft/excelTableData",
  getSavedDetailBefore: "/excelDraft/details",
  deleteFileFromBA: "/excelDraft/detail",
  getMyExcelDrafts: "/excelDraft/myDrafts",
  getAllExcelDraft: "/excelDraft/allDrafts",
  createExcelDraft: "/excelDraft/excelDraft",
  deleteExcelDraft: "/excelDraft",
  updateExcelDraft: "/excelDraft"
}

api.AUTH = {
  login: "/auth/login",
  verification: "/auth/verification",
  obligationAccepted: "/auth/obligationAccepted",
  deleteUserTokenOnLogout: "/auth/deleteUserTokenOnLogout",
  changePassword: "/auth/changePassword",
  getobligationApproveTime: "/auth/obligationApproveTime",
  oidcLogin: "/auth/oidclogin",
  getOidcInfo: "/auth/oidcInfo"
};

api.HTS = {
  saveHtsInformation: "/hts/information",
  saveHtsRecords: "/hts/records",
  getConnections: "/hts/connections",
  htsRecords: "/hts",
  getHtsSubscribers: "/hts/htsSubscribers",
  groups: "/hts/groups",
  allGroups: "/hts/allGroups",
  clearDuplicatedRecords: "/hts/duplicatedRecords",
  getHtsDetails: "/hts/htsDetails",
  getHtsDetailRowCount: "/hts/htsDetailRowCount",
  getConnectionsBetweenGroups: "/hts/connectionsBetweenGroups",
  getHtsSameBase: "/hts/sameBase",
  getDailyCityInfo: "/hts/dailyCityInfo",
  getMostUsedBase: "/hts/mostUsedBase",
  getDistanceBetweenCalls: "/hts/distanceBetweenCalls",
  getConsecutiveCalls: "/hts/consecutiveCalls",
  getHtsRecordTypes: "/hts/htsRecordTypes",
  getSavedFilesBefore: "/hts/htsFileNames",
  downloadHtsDetailsExcel: "/hts/htsDetailsExcel",
  getHtsExcelTemplates: "/hts/htsExcelTemplates",
  getKodIl: "/hts/kodIl",
  getKodIlce: "/hts/kodIlce",
  getCallForwarding: "/hts/callForwarding",
  createHtsBaz: "/hts/baz",
  getSubscriberImei: "/hts/subscriberImei",
  getSubscriberSameImeiUsage: "/hts/subscriberSameImeiUsage",
  getSubscriberSameImeiUsageDetail: "/hts/subscriberSameImeiUsageDetail",
  getOtherBaseSameImeiUsageDetail: "/hts/otherBaseSameImeiUsageDetail",
  getOtherBaseSameImeiUsage: "/hts/otherBaseSameImeiUsage",
  getOtherBaseSubscriberConnection: "/hts/otherBaseSubscriberConnection",
  getCoordinateBasedConnection: "/hts/coordinateBasedConnection",
  uploadHtsExcel: "/hts/uploadHtsExcel",
  updateHtsSubscriber: "/hts/updateSubscriber",
  createHtsDetailsFromExcelRawProcedure: "/hts/createHtsDetailsFromExcelRawProcedure"
}

api.GEOGRAPHICALANALYSIS = {
  geographicalAnalysis: "/geographicalAnalysis",
  getGeographicalAnalysis: "/geographicalAnalysis/getGeographicalAnalysis"
}

api.TRACKINGWARNING = {
  getTrackingWarningAttrs: "/trackingWarning/trackingWarningAttrs",
  trackingWarning: "/trackingWarning",
  allTrackingWarningsForAdmin: "/trackingWarning/allTrackingWarningsForAdmin",
  changeTrackingWarningStatus: "/trackingWarning/trackingWarningStatus",
  changeAllTrackingWarningStatus: "/trackingWarning/allStatus",
  getCommonUsersForNotification: "/trackingWarning/trackingWarningCommonUsers",
  getSelectedCommonUsersForNotification: "/trackingWarning/selectedCommonUsersForNotification",
  deleteAllSelectedTrackingWarnings: "/trackingWarning/allSelected",
  getTrackingWarningNotifications: "/trackingWarning/trackingWarningNotifications"
}

api.EXPANDEDENTITY = {
  wholeExpandedEntity: "/expandedEntity",
  checkSaveAndSearchEntity: "/expandedEntity/saveAndSearchEntities"
}

api.QUERYDRAFT = {
  queryDraft: "/queryDraft",
  allQueryDrafts: "/queryDraft/allQueryDrafts",
  getQueryDraft: "/queryDraft/draft",
  getAIQueryDraft: "/queryDraft/aiquery"
}

api.QUERYTEMPLATE = {
  saveTemplate: "/queryTemplate",
  updateTemplate: "/queryTemplate",
  deleteTemplate: "/queryTemplate",
  getTemplate: "/queryTemplate/template",
  getMyTemplates: "/queryTemplate/myTemplates",
  getAllTemplates: "/queryTemplate/allTemplates",
  getTemplateGroups: "/queryTemplate/groups",
  saveTemplateGroup: "/queryTemplate/groups",
}

api.SHAREDSCHEMA = {
  getUsersForSharedSchema: "/sharedSchema/users",
  getUserFromId: "/sharedSchema/users",
  shareSchemaWithSelectedPeople: "/sharedSchema",
  getMySharedSchemas: "/sharedSchema/mySchemas",
  deleteMySharedSchema: "/sharedSchema",
  getSchemasSharedWithMe: "/sharedSchema/sharedSchemas",
  insertAuditEntryAndGetSchemaData: "/sharedSchema/schemaData",
  getSchemaWithId: "/sharedSchema/schema"
}

api.SIB = {
  createSIB: "/SIB",
  updateSIB: "/SIB",
  deleteSIB: "/SIB/sibSoftDelete",
  getAllSIBs: "/SIB/allSIBs",
  getCustomerSIBs: "/SIB/customerSIBs",
  getSIBsForTransfer: "/SIB/getSIBsForTransfer",
  changeSIBStatus: "/SIB/status",
  getSelectedSIB: "/SIB/selectedSIB",
  downloadSIBAsXML: "/SIB/asXML",
  downloadSIBAsZip: "/SIB/asZip",
  downloadMultipleSIBsAsZip: "/SIB/multipleAsZip",
  getSIBMapping: "/SIB/mapping",
  getSibUsers: "/SIB/sibUsers",
  getSibAlertsHightlights: "/SIB/alertsHighlights",
  getSibHistory: "/SIB/sibHistory",
  getSibInHouseStatement: "/SIB/inHouseStatement",
  updateSibInHouseStatement: "/SIB/inHouseStatement",
  getSuspiciousCategoryText: "/SIB/suspiciousCategoryText",
  getTypologies: "/SIB/typologies",
  uploadExcelData: "/SIB/excel",
  getExcelUploadStatus: "/SIB/excel/status",
  getExcelUploadStatuses: "/SIB/excel/statuses",
  cancelExcelUpload: "/SIB/excel/cancel",
  cancelAllExcelUploads: "/SIB/excel/cancel-all",
  retryDuplicates: "/SIB/excel/retry-duplicates",
  getExcelTable: "/SIB/excelTable",
}


api.INTELLIGENCEDATA = {
  getMyIntelligenceData: "/intelligenceData/myIntelligenceData",
  getAllIntelligenceData: "/intelligenceData/allIntelligenceData",
  getMyIntelligenceDataByEntityPKey: "/intelligenceData/myIntelligenceDataByEntityPKey",
  getIntelligenceDataByEntityPKey: "/intelligenceData/intelligenceDataByEntityPKey",
  runSingleQueryAndGetIntelligenceData: "/intelligenceData/singleQueryIntelligenceData",
  addIntelligenceData: "/intelligenceData",
  changeIntelligenceDataStatus: "/intelligenceData/status",
  deleteIntelligenceData: "/intelligenceData/deletion",
  addIntelligencePhoto: "/intelligenceData/photo",
  getAllPhotosWithId: "/intelligenceData/photos",
  getAdditionalEntityIconPhotoAndDate: "/intelligenceData/iconphoto"
}

api.IMPORTEXCEL = {
  saveExcelDataIntoDb: "/importExcel"
}

api.STOREDCOMMUNICATION = {
  getExtraEntities: "/storedCommunication/extraEntities",
  getDeviceStatistics: "/storedCommunication/devices",
  getDialogStatistics: "/storedCommunication/dialogs",
  getMessages: "/storedCommunication/messages",
  createImportantMessages: "/storedCommunication/importantMessages",
  saveDeviceRelatedPerson: "/storedCommunication/deviceWithPerson",
  deleteDeviceRelatedPerson: "/storedCommunication/deviceWithPerson",
  getImportantMessages: "/storedCommunication/importantMessages",
  getImportantMessagesContent: "/storedCommunication/importantMessageContent",
  getImportantMessagesExtraEntityData: "/storedCommunication/imExtraEntities",
  addExtraEntityIntoImportantMessage: "/storedCommunication/imExtraEntities",
  updateExtraEntityData: "/storedCommunication/imExtraEntities",
  deleteExtraEntityData: "/storedCommunication/imExtraEntities",
  deleteImportantMessageContent: "/storedCommunication/importantMessageContent",
  getDeviceDescriptions: "/storedCommunication/deviceDescriptions",
  saveDeviceDescription: "/storedCommunication/deviceDescription",
  getMessagePageNumber: "/storedCommunication/pageNumber",
  getMessagePageNumberWithImportantMessageId: "/storedCommunication/pageNumberFromImportantMessage",
  getMessageBinaryData: "/storedCommunication/mediaData",
  getAllImportantMessagesForMessage: "/storedCommunication/allImportantMessages",
  deleteImportantMessageGroup: "/storedCommunication/importantMessageGroup",
  getDeviceRelatedPerson: "/storedCommunication/deviceRelatedPerson"
}

api.CASEMANAGEMENT = {
  getMyCases: "/caseManagement",
  getAllCases: "/caseManagement/allCases",
  createCase: "/caseManagement",
  deleteCase: "/caseManagement/caseSoftDelete",
  saveSchema: "/caseManagement/schema",
  deleteCaseSchema: "/caseManagement/schemaDelete",
  saveNote: "/caseManagement/notes",
  updateCaseNote: "/caseManagement/noteUpdate",
  deleteCaseNote: "/caseManagement/noteDelete",
  saveAttachment: "/caseManagement/attachments",
  deleteCaseAttachment: "/caseManagement/attachmentDelete",
  downloadAttachment: "/caseManagement/attachmentDownload",
  previewAttachment: "/caseManagement/attachmentPreview",
  getCaseNotes: "/caseManagement/caseNotes",
  getCaseSchemas: "/caseManagement/caseSchemas",
  getCaseSelectedSchema: "/caseManagement/selectedSchema",
  getCaseAttachments: "/caseManagement/caseAttachments",
  getCaseSibs: "/caseManagement/caseSibs",
  saveEntity: "/caseManagement/entities",
  getCaseInfo: "/caseManagement/info",
  getCaseMainEntities: "/caseManagement/mainEntities",
  getCaseRelatedEntities: "/caseManagement/relatedEntities",
  getCaseHistory: "/caseManagement/history",
  getCasesWithBasicSearch: "/caseManagement/basicSearch",
  getCasesWithEntitySearch: "/caseManagement/entitySearch",
  getEntitiesCases: "/caseManagement/entitiesCases",
  getMainCaseEntityList: "/caseManagement/mainCaseEntityList",
  getCaseIdFromCustomerId: "/caseManagement/caseIdFromCustomerId"
}

api.CHAT = {
  createChat: "/chat",
  deleteChat: "/chat",
  addChatUsers: "/chat/chatUsers",
  getChatUsers: "/chat/chatUsers",
  deleteChatUser: "/chat/chatUsers",
  updateUserForAdmin: "/chat/chatUsers",
  getChatList: "/chat/chatList",
  getChatMsgList: "/chat/chatMessages",
  getChatMsgInfo: "/chat/chatMessageInfo",
  deleteChatMessage: "/chat/chatMessages",
  getMyChatMsgCount: "/chat/getMyChatMsgCount",
  getUsersFilters: "/chat/usersFilters",
  getAdminList: "/chat/adminList",
  sendMailToAdmin: "/chat/mailToAdmin",
}

api.SCENARIOGROUP = "/scenariogroup";

api.SCENARIOALERTS = {
  getGroupedAlertsByEntity: "/scenarioAlert/groupedAlertsByEntity",
  getUserGroupedAlertsByEntity: "/scenarioAlert/userGroupedAlertsByEntity",
  getGroupedAlertDetailByEntity: "/scenarioAlert/groupedAlertDetailByEntity",
  getUserGroupedAlertDetailByEntity: "/scenarioAlert/groupedUserAlertDetailByEntity",
  getAlertDetailByEntity: "/scenarioAlert/alertDetailByEntity",
  getGroupedAlertsByScenario: "/scenarioAlert/groupedAlertsByScenario",
  getGroupedAlertsByTimeElapsed: "/scenarioAlert/groupedAlertsByTimeElapsed",
  getCountGroupedAlertsByTimeElapsed: "/scenarioAlert/countGroupedAlertsByTimeElapsed",
  getUserGroupedAlertsByScenario: "/scenarioAlert/userGroupedAlertsByScenario",
  getGroupedAlertDetailByScenario: "/scenarioAlert/groupedAlertDetailByScenario",
  getUserGroupedAlertDetailByScenario: "/scenarioAlert/userGroupedAlertDetailByScenario",
  getAllAlertUsers: "/scenarioAlert/allAlertUsers",
  getAlertUsers: "/scenarioAlert/alertUsers",
  getMailToUsers: "/scenarioAlert/mailToUsers",
  batchAssign: "/scenarioAlert/alertBatchAssign",
  scenarioAutoAssign: "/scenarioAlert/scenarioAutoAssign",
  updateScenarioAlertState: "/scenarioAlert/alertState",
  updateScenarioMultipleAlertState: "/scenarioAlert/multipleAlertState",
  getAlertData: "/scenarioAlert/alertData",
  getMultipleAlertState: "/scenarioAlert/multipleAlertState",
  assignAlertToUser: "/scenarioAlert/assignAlertToUser",
  getAssignedAlertCount: "/scenarioAlert/getAssignedAlertCount",
  getScenarioAlertHistories: "/scenarioAlert/alertHistories",
  getScenarioNames: "/scenarioAlert/scenarioNameList",
  getNewAlertAndCustomerCount: "/scenarioAlert/alertAndCustomerCount",
  getAutoAssignedAlertData: "/scenarioAlert/autoAssignedAlertData",
  assignAlertEqually: "/scenarioAlert/assignAlertEqually",
  checkMultipleAlertStateForSib: "/scenarioAlert/multipleAlertStateForSib",
  changeAlertStateForSib: "/scenarioAlert/alertStateForSib",
  getSibIdFromAlertId: "/scenarioAlert/sibIdFromAlertId",
  getAlertHighlightDetail: "/scenarioAlert/alertHighlightDetail",
  getAlertScenarioDescription: "/scenarioAlert/alertScenarioDescription",
  getScenarioDescription: "/scenarioAlert/scenarioDescription",
  exportCustomerBasedExcel: "scenarioAlert/excel/customerBased",
  exportCustomerDetailExcel: "scenarioAlert/excel/customerDetail",
  exportCustomerDetailExcelWithHistory: "scenarioAlert/excel/customerDetailWithHistory",
  exportScenarioBasedExcel: "scenarioAlert/excel/scenarioBased",
  exportScenarioDetailExcel: "scenarioAlert/excel/scenarioDetail",
  exportScenarioDetailExcelWithHistory: "scenarioAlert/excel/scenarioDetailWithHistory",
  exportTimeElapsedDetailExcel: "scenarioAlert/excel/timeElapsedDetail",
  getAlertQueryDetail: "/scenarioAlert/alertQueryDetail",
  getMultiAlertQueryDetail: "/scenarioAlert/multiAlertQueryDetail",
  addFileToAlert: "/scenarioAlert/file",
  getAlertFileList: "/scenarioAlert/file",
  deleteAlertFile: "/scenarioAlert/fileDeletion",
  downloadAlertFile: "/scenarioAlert/fileData",
  getAlertSdDescriptions: "/scenarioAlert/sddescriptions",
  getScenarioSummary: "/ScenarioAlert/scenarioSummary",
  getReportFindings: "/ScenarioAlert/reportFindings",
  getReportPersonnel: "/ScenarioAlert/reportPersonnel"
};

api.NOTIFICATIONS = {
  getUserAllNotifications: "/notification/userAllNotifications",
  getUserNotificationCount: "/notification/notificationCount",
  getLastFiveNotifications: "/notification/lastFive",
  changeReadStatus: "/notification/readStatus",
  deleteNotification: "/notification",
  createNotification: "/notification",
  getManualNotificationWithId: "/notification/manualWithId",
  getUnreadMandatoryNotifications: "/notification/unreadMandatory"
}

api.NOTEBOOK = {
  getNote: "/notebook",
  saveNote: "/notebook",
  updateNote: "/notebook",
  deleteNote: "/notebook",
  getMyNoteList: "/notebook/myNotes",
};

api.DATABINDING = {
  saveDataBinding: "/dataBinding",
  getAllDataBindings: "/dataBinding/pagination",
  changeDataBindingStatus: "/dataBinding/status",
  singleQuery: "/dataBinding/simple"
}

api.WRITABLEENTITY = {
  saveWritableEntityData: "/writableEntityData",
  deleteWritableEntityItem: "/writableEntityData/deleteWritableEntityItem",
  approveWritableEntityItem: "/writableEntityData/approveWritableEntity",
  getWritableEntityHistory: "/writableEntityData/history",
  getWritableEntityDataWithPagination: "/writableEntityData/dataWithPagination",
  getMultiEntityData: "/writableEntityData/multientitydata",
  getActiveJandarmaUsers: "/writableEntityData/activeJandarmaUsers",
  getJandarmaUserCity: "/writableEntityData/jandarmaUserCity",
  exportWritableEntityData: "/writableEntityData/export/writableentitydata"
}

api.KYC = {
  getAll: "/kyc/getall",
  getQuery: "/kyc/get",
  saveQury: "/kyc/save",
  getGroupedKycAlerts: "/kyc/groupedkycalerts",
  getGroupedKycAlertDetail: "/kyc/groupedkycalertdetail",
  getAlertdetail: "/kyc/alertdetail",
  kycgroup: "/kyc/kycgroup",
  kycQuery: "/kyc/kycquery",
  queryRule: "/kyc/queryrule",
  queryHighlights: "/kyc/queryhighlights"
}
api.KYCALERT = {
  data: "/kycalert/data",
  details: "/kycalert/detail",
  result: "/kycalert/result",
  updateStatus: "/kycalert/updateUnderReviewStatus",
  selectedUid: "/kycalert/selectedUid",
  exportExcel: "/kycalert/report/excel",
}
api.KYCALERTMANAGEMENTPANEL = {
  resultScores: "/KYCManagement/resultscores",
  createResultScore: "/KYCManagement/createResultScore",
  updateResultScore: "/KYCManagement/updateResultScore",
  deleteResultScore: (id) => `/KYCManagement/deleteResultScore/${id}`,
}
api.RFIMANAGEMENT = {
  rfidatas: "/RFIManagement/rfidatas",
  rfidatadetails: "/RFIManagement/rfidatadetails",
  rfimessages: "/RFIManagement/rfimessages",
  createRfiData: "/RFIManagement/createRfiData",
  createRfiDataDetail: "/RFIManagement/createRfiDataDetail",
  createRfiMessage: "/RFIManagement/createRfiMessage",
  updateRfiOpAct: "/RFIManagement/updateRfiOpAct",
  getAttachments: (rfiMessageId) => `/RFIManagement/getattachments/${rfiMessageId}`,
},

  api.INFORMATIONREQUEST = {
    all: "/InformationRequest/all",
    byId: (id) => `/InformationRequest/${id}`,
    byAlertId: (alertId) => `/InformationRequest/byAlert/${alertId}`,
    create: "/InformationRequest/create",
    update: "/InformationRequest/update",
    submit: (id) => `/InformationRequest/submit/${id}`,
    finalize: "/InformationRequest/finalize",
    evidence: (id) => `/InformationRequest/evidence/${id}`,
  },

  api.SANCTIONQUERY = {
    rfidatas: "/SanctionQuery/finalizeprocess",
  },

  api.PREPAREDQUERY = {
    getAllPreparedQueries: "/preparedQuery/all",
    getPreparedQueryWithId: "/preparedQuery/withId",
    getPreparedQueryInformationsWithId: "/preparedQuery/informations/withId",
    savePreparedQuery: "/preparedQuery",
    updatePreparedQuery: "/preparedQuery",
    deletePreparedQuery: "/preparedQuery",
    getPreparedQueriesWithHeaderId: "/preparedQuery",
    getPreparedQueryDetails: "/preparedQuery/details",
    executePreparedQuery: "/preparedQuery/execution",
    executeAsyncPreparedQuery: "/preparedQuery/asyncexecution",
    prepareAsyncPreparedQuery: "/preparedQuery/asyncexecutionpreperation",
    checkAsyncPreparedQueryReady: "/preparedQuery/asyncPreparedQueryReady",
    getPreparedQueryElements: "/preparedQuery/elements",
    executePreparedQueryExcel: "/preparedQuery/excel",
    getAllPreparedQueriesAndHeaderIds: "/preparedQuery/allWithHeaderIds",
  }

api.INTEGRATED_QUERY = {
  preparedQueriesWithAttribute: "/integratedQuery/preparedQueriesWithAttribute",
  queryAllPreparedQuery: "/integratedQuery/queryAllPreparedQuery",
  getAllIntegratedPreparedQueriesAndHeaderIds: "/preparedQuery/allIntegratedWithHeaderIds"
}
api.FACERECOGNITION = {
  searchFaces: "/faceRecognition"
}
api.CLIENTSETTINGS = {
  getClientSettings: "/clientsettings"
}

api.RESTSERVICES = {
  getall: "restservicesmanagement/list",
  crud: "restservicesmanagement",
  test: "restservicesmanagement/test",
  relatedservicesbyentity: "restservicesmanagement/relatedservicesbyentity",
  relatedservicesbypreparedquery: "restservicesmanagement/relatedservicesbypreparedquery",
  callrestservice: "restservicesmanagement/callrestservice",
  getAllHasStaticMappings: "restservicesmanagement/hasstaticmappings"
}

api.RESTSERVICESENTITYMAPPING = {
  getall: "restservicemappingsmanagement/list",
  crud: "restservicemappingsmanagement",
  getStaticMappingsWithServiceMappingId: "restservicemappingsmanagement/staticMappings"
}

api.FRAUDINCIDENTMANAGEMENT = {
  all: "api/fraud/incident",
  rules: "api/fraud/incident/rules",
  matchedRuleSets: "api/fraud/incident/matchedRuleSets",
  queriedRuleSets: "api/fraud/incident/queriedRuleSets",
  restService: "api/fraud/incident/restService",
  incidentWithInputData: "api/fraud/incident/incidentwithinputdata",
  runRule: "api/fraud/incident/ruleEvidence",
  getUsers: "api/fraud/incident/users",
  assignee: "api/fraud/incident/assignee",
  preparedToIncident: "api/fraud/incident/preparedQueryToIncident",
  execute: "api/fraud/incident/execution",
  status: "api/fraud/incident/status",
  detail: "api/fraud/incident/detail",
  entityServiceActions: "api/fraud/incident/entityserviceactions",
  history: "api/fraud/incident/history",
  attachment: "api/fraud/incidentattachment",
  singleAttachmentDownload: "api/fraud/incidentattachment/single",
  multiAttachmentDownload: "api/fraud/incidentattachment/multi",
  bulkDeleteAttachment: "api/fraud/incidentattachment/bulkDelete",
  notes: "api/fraud/incident/notes",
  logServiceActions: "api/fraud/incident/logserviceactions"
}

api.FRAUDRULES = {
  getAll: "api/fraud/rule/list",
  candidates: "api/fraud/rule/candidates",
  crud: "api/fraud/rule",
  getByEntityId: "api/fraud/rule/getByEntityId",
  changeCandidateState: "api/fraud/rule/candidateStates",
  getRuleCandidateWithQueries: "api/fraud/rule/candidateWithQueries",
  getRuleWithQueries: "api/fraud/rule/withQueries",
  createRuleDeleteApprovalCandidate: "api/fraud/rule/deleteApproval"
}

api.FRAUDRESPONSETYPES = {
  crud: "api/fraud/responseType"
}
api.FRAUDRULEQUERY = {
  crud: "api/fraud/rulequery",
}

api.RULESETMAPPING = {
  crud: "api/fraud/ruleSetMapping",
  getRuleSets: "api/fraud/ruleSetMapping/ruleSets"
}
api.FRAUDRULESETS = {
  crud: "api/fraud/ruleSet",
  history: "api/fraud/ruleset/history"
}
api.FRAUDRULESETRULES = {
  crud: "api/fraud/ruleSetRule"
}

api.FRAUDSERVICEHELPER = {
  getserviceentities: "api/fraud/servicehelper/serviceentities",
  responsetypes: "api/fraud/servicehelper/responsetypes",
  resultsets: "api/fraud/servicehelper/resultsets",
  restservicesbyserviceid: "api/fraud/servicehelper/restservicesbyserviceid",
  serviceresponsesbyserviceid: "api/fraud/servicehelper/serviceresponsesbyserviceid"
}

api.FRAUDSERVICERESPONSES = {
  crud: "api/fraud/serviceresponse",
  allmailusers: "api/fraud/serviceresponse/mailUsers",
  serviceresponsemailuser: "api/fraud/serviceresponse/mailUsersById"
}

api.FRAUDRULESETESPONSES = {
  crud: "api/fraud/rulesetresponse"
}
api.FRAUDRULESETTYPES = {
  crud: "api/fraud/rulesettype"
}

api.FRAUDSERVICERESPONSETRANSITIONS = {
  crud: "api/fraud/serviceresponsetransition",
  servicesByEntity: "api/fraud/serviceresponsetransition/servicesByEntity"
}

api.FRAUDINCIDENTSTATES = {
  crud: "api/fraud/incidentstate"
}

api.FRAUDINCIDENTSTATETRANSITIONS = {
  crud: "api/fraud/incidentstatetransition"
}

api.FRAUDCASEGROUPS = {
  cases: "api/fraud/casegroup/cases",
  crud: "api/fraud/casegroup",
  getCasesByIncidentId: "api/fraud/casegroup/casesofincident",
  myCases: "api/fraud/casegroup/mycases",
  attachment: "api/fraud/caseattachment/attachment",
  singleAttachmentDownload: "api/fraud/caseattachment/attachment/single",
  multiAttachmentDownload: "api/fraud/caseattachment/attachment/multi",
  bulkDeleteAttachment: "api/fraud/caseattachment/attachment/bulkDelete",
  notes: "api/fraud/notes"
}
api.FRAUDCASESTATES = {
  crud: "api/fraud/casestate"
}
api.FRAUDCASESTATETRANSITION = {
  crud: "api/fraud/casestatetransition"
}

api.GRAPHQUERY = {
  query: "graphHc/graphQuery"
}
api.ARTIFICIALINT = {
  executeDatasetSql: "/AI/executeDatasetSql",
  trainModel: "/AI/trainModel",
  saveTrainModel: "/AI/saveTrainModel",
  getModel: "/AI/getModel",
  sendAlert: "/AI/sendAlert",
  getLastModel: "AI/getLastModel",
  trainSimilarCustomer: "AI/trainSimilarCustomer",
  saveSimilarCustomer: "AI/saveSimilarCustomer",
  getSimilarCustomerLastModel: "AI/getSimilarCustomerLastModel",
  getDistinctOrdinal: "/AI/getDistinctOrdinal"
}

api.ENTITYWIZARD = {
  getSchemasFromDatasource: "/entityWizard/getDatasourceSchemas",
  getTablesFromDatasource: "/entityWizard/getDatasourceTables",
  getColumnsFromDatasource: "/entityWizard/getDatasourceColumns",
  getColumnsFromEntityId: "/entityWizard/getEntityColumnsById",
  getEntityAttributesWithMappingsById: "/entityWizard/getEntityAttributesWithMappingsById",
  createEntityAndAttributes: "/entityWizard/createEntityAndAttributes",
  updateEntityAndAttributes: "/entityWizard/updateEntityAndAttributes",
  deleteEntityAndAttributes: "/entityWizard/deleteEntityAndAttributes"
}

api.FRAUDLISTFIBA = {
  getFraudListEntityDataWithPagination: "/fraudList/dataWithPagination",
  createFraudList: "/fraudList/createFraudList",
  updateFraudList: "/fraudList/updateFraudList",
  deleteFraudList: "/fraudList/deleteFraudList",
  updateFraudListAction: "/fraudList/updateFraudListAction"
}

api.FIBACUSTOMERWARNINGS = {
  getCustomerWarnings: "fibaCustomerWarnings",
  createCustomerWarning: "fibaCustomerWarnings",
  updateCustomerWarning: "fibaCustomerWarnings",
  deleteCustomerWarning: "fibaCustomerWarnings/delete"
}

api.FIBATRAPPHONEEMAIL = {
  getTrapMail: "fibaTrapPhoneEmail/trapMail",
  addUpdateDeleteMail: "fibaTrapPhoneEmail/cudTrapMail",
  getTrapEmailUsers: "fibaTrapPhoneEmail/trapMailUsers",
  getTrapPhone: "fibaTrapPhoneEmail/trapPhone",
  getTrapPhoneUsers: "fibaTrapPhoneEmail/trapPhoneUsers",
  addUpdateDeletePhone: "fibaTrapPhoneEmail/cudTrapPhone"

}
api.FIBAACCOUNTHOLD = {
  getAccountHolds: "fibaAccountHold/getHolds",
  removeConstraint: "fibaAccountHold/delete",
  addConstraint: "fibaAccountHold/addNewConstraint"
}
api.FIBACUSTOMERCHANNEL = {
  getCustomerChannels: "fibaChannel/customerChannels",
  updateCustomerChannels: "fibaChannel/customerChannelUpdate"
}

api.FIBACUSTOMERTRACKING = {
  getMessages: "fibaCustomerTracking/customerMessages",
  getMessageGroups: "fibaCustomerTracking/messageGroups",
  sendMail: "fibaCustomerTracking/messages",
  updateReadStatus: "fibaCustomerTracking/messages",
  representative: "fibaCustomerTracking/representative"
}

api.GRAPH = {
  crud: "/graph",
  getGraph: "/graph/getGraph",
  getGraphLogs: "/graph/logs"
}
api.AUTOALERTASSIGN = {
  getAllUsersWithoutAutoAssignAdmin: "autoAlertAssign/getAutoAlertAssignUsers",
  getUsersInFirstGroup: "autoAlertAssign/getUsersInFirstGroup",
  getUsersInSecondGroup: "autoAlertAssign/getUsersInSecondGroup",
  assignUserToGroup: "autoAlertAssign/assignUserToGroup",
  deleteUserFromGroup: "autoAlertAssign/deleteUserFromGroup"
}
api.SIBTRACKING = {
  crud: "/sibTracking",
  getEndDate: "/sibTracking/endDate",
  getSibFromTracking: "/sibTracking/getSibFromTracking",
  getSibTrackingAlerts: "sibTracking/getSibTrackingAlerts",
  getResponsibleSibTrackingUsers: "/sibTracking/getResponsibleSibTrackingUsers",
  sendTracking: "/sibTracking/sendTracking",
  getSibTrackingRemainingDay: "/sibTracking/getMinRemainingDay",
  exportExcel: "/sibTracking/exportExcel",
  deleteSibTrackingAlertRelation: "/sibTracking/deleteSibTrackingAlertRelation"
}
api.SIBTRACKINGSDDESCRIPTION = {
  crud: "/sibTracking/sddescription"
}
api.SIBTRACKINGRDDESCRIPTION = {
  crud: "/sibTracking/rddescription"
}
api.SIBTRACKINGALERTSTATE = {
  getAlertsWithRdState: "/scenarioAlert/alertsWithRdState",
  getSibNextRefNo: "/sibTracking/nextRefNo",
  createNewSibTracking: "/sibTracking/createNewSibTracking",
  updateNewSibTracking: "/sibTracking/updateNewSibTracking",
  deleteSibTracking: "/sibTracking/deleteSibTracking"
}
api.SUSPICIONDESCRIPTION = {
  createSuspicionDescription: "SIBDynamicDescription/createSuspicionDescription",
  updateSuspicionDescription: "SIBDynamicDescription/updateSuspicionDescription",
  getSuspicionDescriptions: "SIBDynamicDescription/getSuspicionDescriptions",
  getSuspicionCategories: "SIBDynamicDescription/getSuspicionCategories",
  deleteDynamicDescription: "SIBDynamicDescription"
}

api.PARENTENTITIES = {
  getParentEntities: "/parentEntityManagement/parentEntities",
  getAllEntities: "/parentEntityManagement/allEntities",
  getEntityAttributes: "/parentEntityManagement/entityAttributes",
  createParentChildEntityMappings: "parentEntityManagement/parentChildEntityMappings",
  getSelectedParentEntityWithNem: "parentEntityManagement/selectedParentEntityWithNem",
  getEntityAttributeMappings: "parentEntityManagement/entityAttributeMappings",
  deleteAttribueMappings: "parentEntityManagement/entityAttributes",
  deleteChildEntity: "parentEntityManagement/childEntity"
}

api.INFORMATIONCARDS = {
  getAllEntities: "entityManagement/allEntitiesBasic",
  getInformationCards: "informationCard/informationCards",
  getInformationCardAttribute: "informationCard/infoCardAttribute",
  saveInformationCard: "informationCard/newInfoCard",
  updateInfoCard: "informationCard/updatedInfoCard",
  deleteInformationCard: "informationCard",
  queryAllPreparedQueriesOfInfoCard: "informationCard/queryAllPreparedQuery",
  exportPdf: "informationCard/exportPdf"
}
api.COMPOUNDQUERIES = {
  getAllEntities: "entityManagement/allEntitiesBasic",
  getCompoundQueries: "compoundQuery/compoundQueries",
  getCompoundQueryAttribute: "compoundQuery/compoundQueryAttribute",
  saveCompoundQuery: "compoundQuery/newCompoundQuery",
  updateCompoundQuery: "compoundQuery/updatedCompoundQuery",
  deleteCompoundQuery: "compoundQuery",
  queryAllPreparedQueriesOfCompoundQuery: "compoundQuery/queryAllPreparedQuery",
  exportPdf: "compoundQuery/exportPdf"
}

api.DIGITALTRACES = {
  getAllEntities: "entityManagement/allEntitiesBasic",
  getDigitalTraces: "digitalTraces/digitalTraces",
  getDigitalTraceAttribute: "digitalTraces/digitalTraceAttribute",
  saveDigitalTrace: "digitalTraces/newDigitalTrace",
  updateDigitalTrace: "digitalTraces/updateDigitalTrace",
  deleteDigitalTrace: "digitalTraces",
  queryAllPreparedQueriesOfDigitalTrace: "digitalTraces/queryAllPreparedQuery",
  exportPdf: "digitalTraces/exportPdf",
  entityTrackingAttributes: "/entityTrackingAttributes",
  trackingAttribute: "/entityTrackingAttributes/trackingAttribute",
}
api.DYNAMICFORMS = {
  getAllEntities: "entityManagement/allWritableEntities",
  getDynamicForms: "dynamicForm/dynamicForm",
  createDynamicForm: "dynamicForm/newDynamicForm",
  deleteDynamicForm: "dynamicForm"
}
api.SPACEGRAPH = {
  generate: "/SpaceGraph/create",
  getAll: "/SpaceGraph/all",
  getById: "/SpaceGraph/",
  getMeta: "/SpaceGraph/meta.json",
  getLabels: "/SpaceGraph/labels.json",
  getCenter: "/SpaceGraph/center",
  getLinks: "/SpaceGraph/links",
  getPositions: "/SpaceGraph/positions/frustum",
  delete: "/SpaceGraph/delete",
};
api.HOMEPAGE = {
  getPhotos: "/homePage/photos",
}

api.PARSEXAM = {
  // Exams
  exams: "/api/Exams",
  examById: "/api/Exams",
  examsForAdmin: "/api/Exams/admin/all",
  categoryBasedExam: "/api/Exams",

  // Categories
  categories: "/api/Categories",
  categoryById: "/api/Categories",
  categoryQuestions: "/api/Categories",

  // Questions
  questions: "/api/Questions",
  questionById: "/api/Questions",

  // Exam Results
  examResults: "/api/ExamResults",
  startExam: "/api/ExamResults/start",
  submitAnswer: "/api/ExamResults",
  completeExam: "/api/ExamResults",
  examResultById: "/api/ExamResults",
  examResultsByExam: "/api/ExamResults/exam",
  canUserStartExam: "/api/ExamResults",
  approveExamRetake: "/api/ExamResults",
  revokeExamRetake: "/api/ExamResults",
  activeExamResult: "/api/ExamResults",
  latestExamResult: "/api/ExamResults",
  adminExamResults: "/api/ExamResults/admin/exam",

  // Exam Sessions
  examSessions: "/api/ExamSessions",
  startExamSession: "/api/ExamSessions/start",
  examSessionByResult: "/api/ExamSessions/by-exam-result",
  questionViewTime: "/api/ExamSessions/question-view-time",

  // Exam Result Permissions
  examResultPermissions: "/api/ExamResultPermissions",
  grantPermission: "/api/ExamResultPermissions/grant",
  canViewExamResult: "/api/ExamResultPermissions/can-view"
}
api.SCENARIOREPORTTEMPLATE = {
  getByScenarioId: "/scenario/scenarioReportTemplate",
  save: "/scenario/scenarioReportTemplate",
}

api.EMAILTEMPLATE = {
  getTemplates: "/emailTemplate/templates",
  getTemplateById: "/emailTemplate/template/",
  createTemplate: "/emailTemplate/template",
  updateTemplate: "/emailTemplate/template",
  deleteTemplate: "/emailTemplate/template/",
  sendBulk: "/emailTemplate/sendBulk"
};
api.BULKEMAIL = {
  searchByTcNo: "/bulkEmail/searchByTcNo"
};
api.LOGRECORDS = {
  getLogRecords: "/logRecords",
  exportLogRecordsExcel: "/logRecords/excel"
}

api.SQLEDITOR = {
  executeQuery: "/sqlEditor/execute",
  saveQuery: "/sqlEditor/savedQuery",
  updateQuery: "/sqlEditor/savedQuery",
  deleteQuery: "/sqlEditor/savedQuery",
  getSavedQueries: "/sqlEditor/savedQueries",
  getSavedQueriesPaginated: "/sqlEditor/savedQueries/paginated",
  getQueryHistory: "/sqlEditor/history",
  getQueryHistoryPaginated: "/sqlEditor/history/paginated",
  getEncryptionKey: "/sqlEditor/encryptionKey"
};

api.CFA_ANALYSIS = {
  execute: "/CfaAnalysis/execute",
  incomeAnalysis: "/CfaAnalysis/income-analysis",
  amlScreening: "/CfaAnalysis/aml-screening",
  fraudScreening: "/CfaAnalysis/fraud-screening",
  contactAnalysis: "/CfaAnalysis/contact-analysis",
  profileSummary: "/CfaAnalysis/profile-summary",
  analysis: "/CfaAnalysis/analysis",
  history: "/CfaAnalysis/history",
  findConnection: "/CfaAnalysis/find-connection"
};


export default api;
